import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ChefEddieGPage from "../pages/chef/page";
import LocavorePodsPage from "../pages/locavore/page";
import CulinaryJourneysPage from "../pages/journeys/page";
import JourneyDetailPage from "../pages/journeys/detail/page";
import BringEddiePage from "../pages/bring/page";
import InviteEddiePage from "../pages/invite/page";
import HireEddiePage from "../pages/hire/page";
import SubmitALocavorePage from "../pages/submit-locavore/page";
import JournalPage from "../pages/journal/page";
import JournalDetailPage from "../pages/journal/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/chef-eddie-g",
    element: <ChefEddieGPage />,
  },
  {
    path: "/locavore-pods",
    element: <LocavorePodsPage />,
  },
  {
    path: "/culinary-journeys",
    element: <CulinaryJourneysPage />,
  },
  {
    path: "/culinary-journeys/:slug",
    element: <JourneyDetailPage />,
  },
  {
    path: "/bring-eddie",
    element: <BringEddiePage />,
  },
  {
    path: "/invite-eddie",
    element: <InviteEddiePage />,
  },
  {
    path: "/hire-eddie",
    element: <HireEddiePage />,
  },
  {
    path: "/submit-a-locavore",
    element: <SubmitALocavorePage />,
  },
  {
    path: "/journal",
    element: <JournalPage />,
  },
  {
    path: "/journal/:slug",
    element: <JournalDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;